// removed by extract-text-webpack-plugin
module.exports = {"contentContainer":"_KcJ9d70yG1EnqePyVm5C","formContainer":"_8nrQMuL1GnAOL_E__QPuS","question3":"-wx5NdtES3DmIOLCHdSlN","radioButton":"_2RcUI4KDykpVGU_2W9QE5Z","screenResults":"_22GgllDyOgwOY7HD2ZTjKu","notes":"fC6mtXxPequhOdP3tskfH","overrideCheckbox":"_1C6Ay0GAADXlY4_EJVeziL","editHistoryRow":"_13aau2dZ9IrAIKGZP4VtCu"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/patientPages/testing/TB.scss
// module id = 444
// module chunks = 0